// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__3Q_ou","dragIcon":"Choice_dragIcon__80qKu","left":"Choice_left__1YzEi","input":"Choice_input__1KR5n"};